export default "__VITE_ASSET__BFNZCEwC__"